import {useEffect} from "react";
import {useFormikContext} from "formik";
import {checkRaceTimetableDoubling} from "../../api/timetables";

const RaceTimetableObserver = ({ callback }) => {
	const { values } = useFormikContext();

	useEffect(() => {
		fetchDoublingRows();
	}, [values.events]);

	const fetchDoublingRows = async () => {
		try {
			const reducedPayload = values.events.map(row => ({
				berks_id: row.berks_id,
				berks_id_2: row.berks_id_2,
				bucks_id: row.bucks_id,
				bucks_id_2: row.bucks_id_2,
				id: row.id,
				start_time: row.start_time,
				event_id: row.event_id,
			}));
			console.log('reducedPayload', reducedPayload);
			const response = await checkRaceTimetableDoubling(reducedPayload);

			if (response.data.status === 'success') {
				callback('doubling', response.data.doubling_rows);
			}
		} catch (error) {
			console.error(error);
		}
	};



	return null;
};

export default RaceTimetableObserver;
